<template>
    <!-- Paso 3: país donde vive y país de destino / del alojamiento. -->
    <form class="bk-card" :class="{ 'is-done': completo }" novalidate aria-labelledby="rg-country" @submit.prevent="handleSubmit">
        <header class="bk-card-head">
            <span class="bk-step" aria-hidden="true">{{ completo ? '✓' : '3' }}</span>
            <div>
                <h2 id="rg-country" class="bk-card-title">{{ $t('auth_nuevo.reg.country.title') }}</h2>
                <p class="bk-card-desc">{{ $t('auth_nuevo.reg.country.desc') }}</p>
            </div>
        </header>

        <div v-if="error" class="bk-auth-alert" role="alert"><p>{{ error }}</p></div>

        <div id="rg-user_country" :class="['bk-combo-full', { 'is-invalid': !!errorDe('user_country') }]">
            <NfCombo
                v-model="formData.user_country"
                :options="opcionesOrigen"
                :label="$t('auth_nuevo.f.origin')"
                :search-placeholder="$t('auth_nuevo.f.country_search')"
                :empty-text="$t('auth_nuevo.f.country_empty')"
                @change="error = ''"
            />
            <p v-if="errorDe('user_country')" class="bk-choice-error" role="alert">{{ errorDe('user_country') }}</p>
        </div>

        <div id="rg-interest_country" :class="['bk-combo-full', { 'is-invalid': !!errorDe('interest_country') }]">
            <NfCombo
                v-model="formData.interest_country"
                :options="opcionesDestino"
                :label="countryLabel"
                :search-placeholder="$t('auth_nuevo.f.country_search')"
                :empty-text="$t('auth_nuevo.f.country_empty')"
                @change="error = ''"
            />
            <p v-if="errorDe('interest_country')" class="bk-choice-error" role="alert">{{ errorDe('interest_country') }}</p>
        </div>

        <button type="submit" class="bk-btn bk-btn--primary bk-auth-submit" :disabled="isLoading">
            <span v-if="isLoading" class="bk-spinner" aria-hidden="true"></span>
            {{ isLoading ? $t('auth_nuevo.reg.saving') : $t('auth_nuevo.reg.finish') }}
        </button>
    </form>
</template>

<script>
import userCountryList from "@/assets/data/users-countries-data.json";
import accommodationCountryList from "@/assets/data/accommodations-countries-data.json";
import { nombrePais } from "@/assets/data/paisesTelefono";
import NfCombo from "@/components/Formulario/NfCombo.vue";

import { mapState, mapActions } from "vuex";

// La API recibe el nombre del país tal cual estaba en el select viejo
// ("Argentina", "Spain"…, sin el "(+54)"): ese sigue siendo el valor. En
// pantalla se muestra traducido y con bandera.
const opciones = (lista, locale) => lista
    .map(item => {
        const iso = item.code === 'DS' ? 'AS' : item.code;
        return { value: item.name.replace(/\s\(\+\d+\)$/, ''), label: nombrePais(iso, locale), flag: iso };
    })
    .sort((a, b) => a.label.localeCompare(b.label, locale));

export default {
    name: "Register",
    components: { NfCombo },
    data() {
        return {
            formData: {
                interest_country: '',
                user_country: '',
            },
            isLoading: false,
            intento: false,
            error: ''
        };
    },
    methods: {

        ...mapActions("userNew", [
            "setUserCountry"
        ]),

        errorDe(campo) {
            return this.intento && !this.formData[campo] ? this.$t('validations.required') : '';
        },

        async handleSubmit() {
            if (this.isLoading) return;
            this.intento = true;
            this.error = '';
            const falta = ['user_country', 'interest_country'].find(c => !this.formData[c]);
            if (falta) {
                const el = document.querySelector(`#rg-${falta} .nf-combo-trigger`);
                if (el) el.focus();
                return;
            }

            const tipoLead = localStorage.getItem('userType');
            if (!tipoLead) {
                console.error('El valor de userType no está definido en localStorage.');
            }

            const data = {
                'user_country': this.formData.user_country,
                'interest_country': this.formData.interest_country,
                'customFields.Tipo de lead': tipoLead // Enviar como customFields.Tipo de lead
            };
            this.isLoading = true;
            try {
                await this.setUserCountry(data);
                // Bloquear scroll del body
                document.body.style.overflow = 'hidden';
                // Emitir evento con nombre para que Layout muestre el modal
                const userName = (this.$store.state.user && this.$store.state.user.nombre) || localStorage.getItem('nombre') || '';
                this.$emit('registration-complete', userName);

            } catch (e) {
                console.error("Error en setUserCountry:", e, e && e.response && e.response.data);
                this.error = e && e.response ? this.$t('auth_nuevo.reg.err_country') : this.$t('auth_nuevo.err.network');
            } finally {
                this.isLoading = false;
            }
        }
    },
    computed: {
        ...mapState("userNew", [
            "userType"
        ]),
        opcionesOrigen() {
            return opciones(userCountryList, this.$i18n.locale);
        },
        opcionesDestino() {
            return opciones(accommodationCountryList, this.$i18n.locale);
        },
        completo() {
            return !!(this.formData.user_country && this.formData.interest_country);
        },
        countryLabel() {
            return this.userType === 'anfitrion'
                ? this.$t('auth_nuevo.f.accommodation')
                : this.$t('auth_nuevo.f.destination');
        }
    }
};
</script>
